import React, { useCallback } from "react";
//import PropTypes from 'prop-types';

import Icon from "components/Icon";
import Popover from "components/Popover";
import SelectList, { SelectListItem } from "playground/ui/SelectList";
import { OverlayForm, useFormContext } from "playground/cms/Form";
import PageTitleSlug from "./../PageTitleSlug";
import Button from "components/Button";

import "./style.css";
import { useActions } from "state/hooks";
import { pathUnset } from "state/actions/data";

function EditPageUrl(props) {
    const { type, id, isPage, onClose } = props;
    const { onCancel, isValid, isPending, onSave } = useFormContext();
    const { onUnsetPath } = useActions({ onUnsetPath: pathUnset });
    const reject = () => {
        onUnsetPath([type, id, "slug"]);
        onClose();
    };
    const submit = () => {
        onSave();
        onClose();
    };
    return (
        <div className={"pad-md rows gap-md"}>
            <PageTitleSlug type={type} id={id} isPage={isPage} />
            <div className={"cols gap-xs"}>
                <Button onClick={reject} color={"default"} fullWidth>
                    Anuluj
                </Button>
                <Button
                    onClick={submit}
                    disabled={!isValid || isPending}
                    fullWidth
                >
                    Zapisz
                </Button>
            </div>
        </div>
    );
}

const anchorOrigin = {
    vertical: "bottom",
    horizontal: "left",
};

export function PageTitleUrl(props) {
    const {
        type,
        id,
        host,
        slug,
        title,
        titlePlaceholder,
        isPage,
        edit,
        onEdit,
        onOpen,
    } = props;

    const handleClose = useCallback(() => onEdit(false), [onEdit]);

    return (
        <>
            <div className={"page-title-url"} onClick={() => onEdit(true)}>
                <span className={"page-title"}>
                    <span className={"page-title-wrap"}>
                        {title ? (
                            title
                        ) : (
                            <span className={"page-title-placeholder"}>
                                {titlePlaceholder}
                            </span>
                        )}
                    </span>{" "}
                    <div className={"title-edit-icon"}>
                        <Icon>mui-edit</Icon>
                    </div>
                </span>
                {isPage && (
                    <span className={"slug-domain"}>
                        <div className={"slug-url"}>
                            <span className={"slug-host"}>/</span>
                            <span className={"slug-value"}>{slug}</span>
                        </div>
                    </span>
                )}
            </div>
            <OverlayForm
                open={edit}
                onClose={null}
                position={"center"}
                width={"md"}
                fullHeight={false}
            >
                {edit && (
                    <EditPageUrl
                        isPage={isPage}
                        type={type}
                        id={id}
                        onClose={handleClose}
                    />
                )}
            </OverlayForm>
        </>
    );
}

PageTitleUrl.propTypes = {};

PageTitleUrl.defaultProps = {};

export default PageTitleUrl;
